export default __webpack_public_path__ + "5f4128d4372b6a2b67a42d4105361ee3.mp3";